import {DotProgress} from '@wandb/components';

import styles from './ShellLoader.module.css';

/**
 * Fills its parent by default, which suits the shell frame's content row. A
 * loader rendered with nothing sized above it, as on the identity surface,
 * asks for `fullPage` to take the viewport instead.
 */
export const ShellLoader = ({
  label,
  fullPage = false,
}: {
  label: string;
  fullPage?: boolean;
}) => (
  <div className={fullPage ? styles.page : styles.loader}>
    <DotProgress aria-label={label} />
  </div>
);
